import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { hideMessage } from "../actions";
import CircularProgress from "@material-ui/core/CircularProgress";
import IntlMessages from "../util/IntlMessages";
import SignInAdminForm from "../components/form/authen/SignInAdminForm";
import SignInDealerForm from "../components/form/authen/SignInDealerForm";
import SweetAlert from "react-bootstrap-sweetalert";
import { NotificationContainer, NotificationManager } from "react-notifications";

class SignIn extends React.Component {
	componentDidUpdate() {
		/*
		if (this.props.showMessage) {
			setTimeout(() => {
				this.props.hideMessage();
			}, 100);
		}
		*/
		if (this.props.authUser !== null) {
			this.props.history.push("/");
		}
	}

	render() {
		const { match, showMessage, loader, alertMessage } = this.props;

		return (
			<div className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
				<div className="app-login-main-content">
					<div className="app-logo-content d-flex align-items-center justify-content-center">
						<Link className="logo-lg" to="/">
							<img src={require("assets/images/logo.png")} className="img-fluid" alt="" />
						</Link>
					</div>
					{match.path === "/signin" && (
						<div className="app-login-content">
							<div className="app-login-header mb-4">
								<h1 style={{fontSize: 30}}>
									<IntlMessages id="signin.dealer.hint" />
								</h1>
								<hr />
								<h2>
									<IntlMessages id="signin" />
								</h2>
								<h3>
									<IntlMessages id="signin.dealer" />
								</h3>
							</div>
							<div className="app-login-form">
								<SignInDealerForm />
							</div>
							<hr />
							<h4>
								<IntlMessages id="note" />
							</h4>
							<p>
								<IntlMessages id="signin.dealer.hint.1" />
								<br />
								<IntlMessages id="signin.dealer.hint.2" />
								<br />
								<IntlMessages id="signin.dealer.hint.3" />
							</p>
							{false && (
							<>
							<h4>
								<IntlMessages id="manual" />
							</h4>
							<p>
								<table>
									<tr>
										<td style={{verticalAlign: "top"}}>
											<a href="http://bit.ly/32wQVOC" target="_blank" >
												<i class="zmdi zmdi-file-text zmdi-hc-fw" ></i>
											</a>
										</td>
										<td style={{verticalAlign: "top"}}>
											<a href="http://bit.ly/32wQVOC" target="_blank" >
												<IntlMessages id="manual.dashboard" />
											</a>
										</td>
									</tr>
									<tr>
										<td style={{verticalAlign: "top"}}>
											<a href="http://bit.ly/2YZQVOC" target="_blank" >
												<i class="zmdi zmdi-file-text zmdi-hc-fw" ></i>
											</a>
										</td>
										<td style={{verticalAlign: "top"}}>
											<a href="http://bit.ly/2YZQVOC" target="_blank" >
												<IntlMessages id="manual.qvoc" />
											</a>
										</td>
									</tr>
								</table>
							</p>
							</>
							)}
						</div>
					)}
					{match.path === "/signin/admin" && (
						<div className="app-login-content">
							<div className="app-login-header mb-4">
								<h1>
									<IntlMessages id="signin" />
								</h1>
								<h3>
									<IntlMessages id="signin.user" />
								</h3>
							</div>
							<div className="app-login-form">
								<SignInAdminForm />
							</div>
						</div>
					)}
				</div>
				{loader && (
					<div className="loader-view">
						<CircularProgress />
					</div>
				)}

				{/*
				{showMessage && NotificationManager.error(alertMessage)}
				<NotificationContainer />
				*/}
				<SweetAlert
					show={showMessage}
					title={alertMessage}
					confirmBtnText={<IntlMessages id="commands.confirm" />}
					onConfirm={() => {
						this.props.hideMessage();
					}}
				/>
			</div>
		);
	}
}

const mapStateToProps = ({ auth: { authUser }, notify }) => {
	const { loader, alertMessage, showMessage } = notify;
	return { loader, alertMessage, showMessage, authUser };
};

export default connect(
	mapStateToProps,
	{
		hideMessage
	}
)(SignIn);
